import { render } from "./InternetConfigure.vue?vue&type=template&id=dcbee600"
import script from "./InternetConfigure.vue?vue&type=script&lang=js"
export * from "./InternetConfigure.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__